module.exports = __webpack_public_path__ + "static/media/conversation9.667efbae.jpg";